import { css } from '@emotion/core';
import { useIntl, Link } from 'gatsby-plugin-intl';
import React from 'react';
import { Desktop, Tablet } from '../../constants/responsive';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import ScrollContainer from 'react-indiana-drag-scroll';
import Slider from 'react-slick';
import Arrow from '../../svgs/smart-stock/Arrow.svg';
// 产品卡片
const Card = ({ data, val }) => {
  const intl = useIntl();
  const bgImg = intl.formatMessage({ id: `${data}.img-link` });
  const imgData = useStaticQuery(graphql`
    query {
      GlobalTechGiants: file(
        relativePath: {
          eq: "individuals/active-approach/Global-Tech-Giants.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ProfitMakers: file(
        relativePath: { eq: "individuals/active-approach/Profit-Makers.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      BusinessWinners: file(
        relativePath: { eq: "individuals/active-approach/Business-Winners.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ChineseTechStars: file(
        relativePath: {
          eq: "individuals/active-approach/Chinese-Tech-Stars.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      QualityBlueChips: file(
        relativePath: {
          eq: "individuals/active-approach/Quality-Blue-Chips.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HiddenGems: file(
        relativePath: { eq: "individuals/active-approach/Hidden-Gems.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HighDividends: file(
        relativePath: { eq: "individuals/active-approach/High-Dividends.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      PropertyMoguls: file(
        relativePath: { eq: "individuals/active-approach/Property-Moguls.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      USMarketLeaders: file(
        relativePath: {
          eq: "individuals/active-approach/US-Market-Leaders.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HealthIsWealth: file(
        relativePath: { eq: "individuals/active-approach/Health-Is-Wealth.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      HongKongMarketLeaders: file(
        relativePath: {
          eq: "individuals/active-approach/Hong-Kong-Market-Leaders.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ABetterWorld: file(
        relativePath: { eq: "individuals/active-approach/A-Better-World.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ESGHK: file(
        relativePath: { eq: "individuals/active-approach/ESG-HK.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 365) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  // 从传进来的imgURL中截出imgName并转成驼峰命名形式
  const imgName = bgImg
    .slice(bgImg.lastIndexOf('/') + 1, bgImg.lastIndexOf('.'))
    .replace(/-/g, '');
  // 显示在页面内的各产品pid
  /*
  32: SmartGlobal
  33: SmartGlobalMax
  3310: 全球科技巨头
  3110: 盈利龙头
  3210: 长期赢家
  2310: 大中华科技股
  4411: 高质量蓝筹股
  4511: 低估值潜力股
  2170: 收息之选
  2160: 房地产首选股
  3130: 世界行业龙头
  3140: 生物医疗股
  2130: 港股行业龙头
  3180: 美好未来
  */
  const pids = {
    'active-approach': {
      1: 3310,
      2: 3110,
      3: 3210,
      4: 2310,
      5: 4411,
      6: 4511,
      7: 2170,
      8: 2160,
      9: 3130,
      10: 3140,
      11: 2130,
      12: 3180,
      13: 2180,
    }, // 精选主题
  };
  return (
    // Link：react跳转组件
    <div
      // to={`/product/${pids['active-approach'][val]}`}
      css={css`
        flex: 0 0 auto;
        width: 213px;
        height: 133px;
        border-radius: 15px;
        margin-right: 10px;
        :last-child {
          margin-right: 0;
        }
        ${Tablet} {
          width: 320px;
          height: 200px;
          margin-right: 20px;
          :last-child {
            margin-right: 0;
          }
        }
        ${Desktop} {
          width: 386px;
          height: 241px;
          margin-right: 24px;
          :last-child {
            margin-right: 0px;
          }
        }
      `}
    >
      {/* 背景图 */}
      <div
        css={css`
          background: ${`url(${imgData[imgName].childImageSharp.fluid.src})`}
            center/auto 100% no-repeat border-box border-box;
          background-size: cover;
          flex: 0 0 auto;
          width: 213px;
          height: 133px;
          border-radius: 15px;
          ${Tablet} {
            width: 320px;
            height: 200px;
          }
          ${Desktop} {
            width: 386px;
            height: 241px;
          }
        `}
      >
        {/* 半透明遮罩 */}
        <div
          css={css`
            width: 213px;
            height: 133px;
            border-radius: 15px;
            background-color: rgba(0, 0, 0, 0.3);
            padding: 16px 2px 0 11px;
            ${Tablet} {
              width: 320px;
              height: 200px;
              padding: 27px 2px 0 22px;
            }
            ${Desktop} {
              width: 386px;
              height: 241px;
              padding: 27px 10px 0 22px;
            }
          `}
        >
          {/* title */}
          <div
            css={css`
              color: #ffffff;
              font-size: 16px;
              font-weight: 500;
              line-height: 1.13;
              ${Tablet} {
                font-size: 26px;
                font-weight: bold;
                line-height: normal;
              }
              ${Desktop} {
                font-size: 28px;
                font-weight: bold;
                line-height: normal;
              }
            `}
          >
            {intl.formatMessage({ id: `${data}.title` })}
          </div>
          {/* description */}
          <div
            css={css`
              color: #ffffff;
              font-size: 14px;
              font-weight: normal;
              line-height: 1.29;
              margin-top: 11px;
              width: 184px;
              ${Tablet} {
                font-size: 22px;
                line-height: 1.36;
                margin-top: 15px;
                width: 277px;
              }
              ${Desktop} {
                font-size: 26px;
                line-height: 1.15;
                margin-top: 13px;
                width: 350px;
              }
            `}
          >
            {intl.formatMessage({ id: `${data}.description` })}
          </div>
        </div>
      </div>
    </div>
  );
};
// 右按钮
const MoveRight = (props) => {
  const { className, style, onClick } = props;
  return (
    <div onClick={onClick} className={className} style={style}>
      <Arrow
        width={70}
        css={css`
          transform: translate(-42px, -50px);
        `}
      />
    </div>
  );
};
// 左按钮
const MoveLeft = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      onClick={onClick}
      className={className}
      style={{ ...style, zIndex: '100' }}
    >
      <Arrow
        width={70}
        css={css`
          transform: translate(-31px, -52px) rotate(180deg);
        `}
      />
    </div>
  );
};

const SmartStockPortfolios = ({ name = 'us', productList = [] }) => {
  const intl = useIntl();
  return (
    <div>
      {/* title */}
      <div
        css={css`
          color: #161616;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.33;
          margin-bottom: 6px;
          ${Tablet} {
            font-size: 28px;
            font-weight: 500;
            line-height: 1.71;
            margin-bottom: 14px;
          }
          ${Desktop} {
            font-size: 36px;
            font-weight: 500;
            line-height: 0.92;
            margin-bottom: 30px;
          }
        `}
      >
        {intl.formatMessage({ id: `individuals.smart-stock.${name}-stock` })}
      </div>
      {/* 【产品入口卡片】- WEB端 */}
      {productList.length >= 3 && (
        // 【WEB】- 当卡片数量大于等于3时：卡片点击滚动，不自动播放
        <Slider
          slidesToShow={3}
          slidesToScroll={1}
          infinite
          nextArrow={<MoveRight />}
          prevArrow={<MoveLeft />}
          css={css`
            display: none;
            ${Tablet} {
              display: none;
            }
            ${Desktop} {
              display: block;
              width: 1230px;
              position: relative;
            }
          `}
        >
          {productList.map((val, index) => {
            return (
              <Card
                key={`${name}-${index}`}
                data={`individuals.active-approach.card-${val}`}
                val={val}
              />
            );
          })}
        </Slider>
      )}
      {productList.length < 3 && (
        // 【WEB】- 当卡片数量小于3时：卡片全部静态显示
        <div
          css={css`
            display: none;
            ${Tablet} {
              display: none;
              justify-content: flex-start;
            }
            ${Desktop} {
              display: flex;
              justify-content: flex-start;
            }
          `}
        >
          {productList.slice(0, 4).map((val, index) => {
            return (
              <Card
                key={`${name}-${index}`}
                data={`individuals.active-approach.card-${val}`}
                val={val}
              />
            );
          })}
        </div>
      )}
      {/* 【产品入口卡片】- IPAD端、MOBILE端 拖动 */}
      <ScrollContainer
        css={css`
          width: 100%;
          display: flex;
          ${Desktop} {
            display: none;
          }
        `}
      >
        {productList.map((val, index) => {
          return (
            <Card
              key={`${name}-${index}`}
              data={`individuals.active-approach.card-${val}`}
              val={val}
            />
          );
        })}
      </ScrollContainer>
    </div>
  );
};

export default SmartStockPortfolios;
